import { render } from "./distributor-links-cell.vue?vue&type=template&id=133a20f2&ts=true"
import script from "./distributor-links-cell.vue?vue&type=script&lang=ts"
export * from "./distributor-links-cell.vue?vue&type=script&lang=ts"

import "./distributor-links-cell.vue?vue&type=style&index=0&id=133a20f2&lang=scss"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__